import { EventBus } from '../../libs/event-bus';
import Vue from 'vue';
import { Inertia } from '@inertiajs/inertia';
import axios from 'axios';
export default {
  data() {
    return {
      cartItems: [],
      shopping_cart: [],
      shopping_cart_details: {
        total: 0,
        count: 0,
      },
    };
  },

  methods: {
    setShoppingCart(shopping_cart) {
      const clonedCart = Array.isArray(shopping_cart) ? structuredClone(shopping_cart) : [];
      this.shopping_cart = clonedCart;
      this.cartItems = clonedCart;

      EventBus.$emit('cartUpdated');

    },

    setShoppingCartDetails(details) {
      this.shopping_cart_details = {
        total: details?.total ?? 0,
        count: details?.count ?? 0,
      };

      EventBus.$emit('cartUpdated');

    },

    addProductToCart(product, quantity = 1) {
      if (typeof product.size !== 'string' && product.size !== false) {
        throw new Error('Invalid size value');
      }
      if (typeof product.color !== 'string' && product.color !== false) {
        throw new Error('Invalid color value');
      }

      const existingItem = this.getProduct(product);

      if (existingItem) {
        existingItem.quantity += quantity;
      } else {
        this.cartItems.push({ product: structuredClone(product), quantity });
      }

      Vue.$toast.success('Товар добавлен в корзину');
      this.saveCart();
    },

    removeFromCart(product) {
      const index = this.cartItems.findIndex(
        (item) =>
          item.product.id === product.id &&
          item.product.color === product.color &&
          item.product.size === product.size
      );

      if (index !== -1) {
        this.cartItems.splice(index, 1);
        this.saveCart();
      }
    },

    updateQuantity(product, quantity) {
      const existingItem = this.getProduct(product);

      if (existingItem) {
        existingItem.quantity = quantity;
        // Обновляем total_formatted при изменении количества
        existingItem.product.total_formatted = existingItem.product.price_formatted;

        if (existingItem.quantity <= 0) {
          this.removeFromCart(product);
        } else {
          this.saveCart();
        }
      }
    },

    getCartTotal(cartItems) {
      let total = 0;
      let count = 0;

      cartItems.forEach((item) => {
        total += item.product.price * item.quantity;
        count += item.quantity;
      });

      this.shopping_cart_details = {
        total,
        total_formatted: total.toLocaleString('ru-RU', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace('.', ','),
        count,
      };

      axios.post('/cart', {
        shopping_cart_details: this.shopping_cart_details,
      });

    },

    getCart() {
      return structuredClone(this.cartItems);
    },

    getProduct(product) {
      return this.cartItems.find(
        (item) =>
          item.product.id === product.id &&
          item.product.color === product.color &&
          item.product.size === product.size
      );
    },

    saveCart() {
      const cartClone = structuredClone(this.cartItems);

      this.getCartTotal(cartClone);

      axios.post('/cart', {
        shopping_cart: cartClone,
      })

      EventBus.$emit('cartUpdated');

    },

    getCartDetails() {
      return structuredClone(this.shopping_cart_details);
    },

    clearCart() {
      this.cartItems = [];

      this.shopping_cart = [];
      this.shopping_cart_details = {
        total: 0,
        count: 0,
      };

      axios.post('/cart', {
        shopping_cart: [],
        shopping_cart_details: { total: 0, count: 0 },
      }).then(() => {
        EventBus.$emit('cartUpdated');
      });
    },
  },
};
